import { render } from "./ConnectWalletAuth.vue?vue&type=template&id=4540aeaa&scoped=true"
import script from "./ConnectWalletAuth.vue?vue&type=script&lang=js"
export * from "./ConnectWalletAuth.vue?vue&type=script&lang=js"

import "./ConnectWalletAuth.vue?vue&type=style&index=0&id=4540aeaa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4540aeaa"]])

export default __exports__